<template>
  <div class="order">
    <Header />
    <Nav />
    <div class="pages">
      <div class="order-menu">
          宏云课堂
          <img src="../assets/icon/right-gray.svg" alt="">
          我的订单
      </div>
      <div class="order-title">
        <h4>我的订单</h4>
        <span>共<i>5</i>笔订单</span>
      </div>
      <div class="order-search">
        <ul>
          <li class="active">全部订单</li>
          <li>待支付</li>
          <li>已支付</li>
          <li>已取消</li>
        </ul>
        <div class="order-search-input">
          <img src="../assets/order/search.svg" alt="">
          <input type="text" placeholder="搜索预设文案">
        </div>
        <div class="order-search-clear">取消</div>
      </div>
      <div class="order-td">
        <span>课程目录</span>
        <span>课程名称</span>
        <span>数量</span>
        <span>订单金额</span>
        <span>实付金额</span>
        <span>订单状态</span>
        <span>操作</span>
      </div>
      <div class="order-list">
        <div class="order-item">
          <div class="order-item-top">
            <b>2021-05-27</b>
            <b>订单号：<span>12132132313</span></b>
          </div>
          <div class="order-item-bottom">
            <img src="../assets/company/list.png" alt="">
            <h6>课程名称永兴科技发展有限公司</h6>
            <b>*1</b>
            <span>¥599</span>
            <i>¥399</i>
            <u>交易完成</u>
            <div class="do">
              <div class="status">去评价</div>
            </div>
          </div>
        </div>
        <div class="order-item">
          <div class="order-item-top">
            <b>2021-05-27</b>
            <b>订单号：<span>12132132313</span></b>
          </div>
          <div class="order-item-bottom">
            <img src="../assets/company/list.png" alt="">
            <h6>课程名称永兴科技发展有限公司</h6>
            <b>*1</b>
            <span>¥599</span>
            <i>¥399</i>
            <u class="pay">待支付</u>
            <div class="do">
              <div class="topay">立即支付</div>
              <div class="cancal">取消订单</div>
            </div>
          </div>
        </div>
        <div class="order-item">
          <div class="order-item-top">
            <b>2021-05-27</b>
            <b>订单号：<span>12132132313</span></b>
          </div>
          <div class="order-item-bottom">
            <img src="../assets/company/list.png" alt="">
            <h6>课程名称永兴科技发展有限公司</h6>
            <b>*1</b>
            <span>¥599</span>
            <i>¥399</i>
            <u class="cancal">已取消</u>
            <div class="do">
              <div class="del">删除订单</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from "../components/Fixed.vue";
export default {
  name: "Order",
  components: {
    Header,
    Nav,
    Footer,
    Fixed
  },
};
</script>

<style lang="less" scoped>
.order {
  &-menu {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
    img {
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &-title {
    width: 1300px;
    margin: 0 auto;
    height: 60px;
    background: #ffffff;
    display: flex;
    align-items: center;
    h4 {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 60px;
      margin-left: 40px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 60px;
      margin-left: 12px;
      i {
        color: #ff7e20;
        font-style: normal;
      }
    }
  }
  &-search {
    width: 1300px;
    margin: 7px auto 0;
    height: 52px;
    display: flex;
    align-items: center;
    background: #fff;
    ul {
      flex: 1;
      display: flex;
      align-items: center;
      padding-left: 77px;
      li {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        width: 167px;
        text-align: center;
        &.active {
          width: 96px;
          height: 40px;
          background: rgba(255,122,56,0.26);
          border-radius: 24px;
        }
      }
    }
    &-input {
      width: 236px;
      height: 32px;
      background: #F3F3F3;
      border-radius: 3px;
      display: flex;
      align-items: center;
      img {
        width: 14px;
        height: 14px;
        margin-left: 12px;
      }
      input {
        background: transparent;
      }
    }
    &-clear {
      margin: 0 48px 0 12px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0052D9;
      line-height: 19px;
    }
  }
  &-td {
    width: 1300px;
    height: 52px;
    background: #EEEEEE;
    margin: 0 auto;
    span {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 52px;
      &:nth-child(1) {
        margin-left: 96px;
      }
      &:nth-child(2) {
        margin-left: 153px;
      }
      &:nth-child(3) {
        margin-left: 118px;
      }
      &:nth-child(4) {
        margin-left: 109px;
      }
      &:nth-child(5) {
        margin-left: 51px;
      }
      &:nth-child(6) {
        margin-left: 78px;
      }
      &:nth-child(7) {
        margin-left: 157px;
      }
    }
  }
  &-list {
    width: 1300px;
    margin: 0 auto;
    background: #fff;
    overflow: hidden;
  }
  &-item {
    width: 1200px;
    height: 164px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    margin: 20px auto;
    &-top {
      height: 42px;
      background: #F8F8F8;
      b {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202429;
        line-height: 42px;
        span {
          color: #666666;
        }
        &:nth-child(1) {
          margin-left: 41px;
        }
        &:nth-child(2) {
          margin-left: 47px;
        }
      }
    }
    &-bottom {
      height: 124px;
      display: flex;
      align-items: center;
      img {
        width: 100px;
        height: 56px;
        margin-left: 42px;
      }
      h6 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202429;
        line-height: 25px;
        margin-left: 47px;
      }
      b {
        font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #202429;
line-height: 25px;
margin-left: 19px;
      }
      span {
        font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #666666;
line-height: 25px;
margin-left: 111px;
      }
      i {
        font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #FF7A38;
line-height: 25px;
        margin-left: 80px;
        font-style: normal;
      }
      u {
        width: 4em;
        text-decoration: none;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #666666;
        line-height: 25px;
        margin-left: 90px;
        &.pay {
          color: #FF7A38;
        }
        &.cancal {
          color: #999999;
        }
      }
      .do {
        margin-left: 130px;
        .status {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #666666;
          line-height: 38px;
        }
        .topay {
          width: 90px;
          height: 30px;
          background: #FFF1F0;
          border-radius: 3px;
          border: 1px solid #FFA39E;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #CF1322;
          line-height: 30px;
          text-align: center;
        }
        .cancal {
          width: 90px;
          height: 30px;
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          margin-top: 10px;
        }
        .del {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0,0,0,0.65);
          line-height: 32px;
          width: 88px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid #D9D9D9;
          text-align: center;
        }
      }
    }
  }
}
</style>